import { defineStore } from "pinia";
import {
  api,
  type Result,
  Success,
  watchRequest,
  type QueryParams,
  type ResultOkRef,
} from "../api";
import {
  DriverResponseSchema,
  type DriverPayload,
  type DriverResponse,
} from "../schemas/driver";
import { PaginatedSchema, type Paginated } from "../schemas/paginated";
import {
  DriverAccountSchema,
  type DriverAccount,
} from "../schemas/user";
import { markRaw } from "vue";

class DriverApi {
  private readonly url = "/drivers/";
  private readonly availableAccountsUrl = "/drivers/available-users/";

  getDrivers(
    filters?: QueryParams,
  ): ResultOkRef<Success<Paginated<DriverResponse[]>>> {
    return watchRequest(
      this.url,
      PaginatedSchema(DriverResponseSchema),
      filters,
    );
  }

  getAvailableAccounts(): ResultOkRef<Success<DriverAccount[]>> {
    return watchRequest(
      this.availableAccountsUrl,
      DriverAccountSchema.array(),
    );
  }

  createDriver(payload: DriverPayload): Promise<Result<DriverResponse>> {
    return api.post(this.url, DriverResponseSchema, payload);
  }

  updateDriver(
    id: number,
    payload: DriverPayload,
  ): Promise<Result<DriverResponse>> {
    return api.patch(this.url + `${id}/`, DriverResponseSchema, payload);
  }

  deleteDriver(id: number): Promise<Result<void>> {
    return api.delete(this.url + `${id}/`);
  }
}

const store = defineStore("driver", () => ({
  api: markRaw(new DriverApi()),
}));

export function useDrivers() {
  return store().api;
}
